// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"AttributesDropdown_ItemsWrapper__rySFk","Slide":"AttributesDropdown_Slide__Uzvl8","Active":"AttributesDropdown_Active__xqSVY"};